// src/utils/common/format.js

export const DISPLAY = {
  NO_DATA: "該当なし",
  ERROR: "エラー",
  INVALID: "無効",
  LOADING: "読込中",
};

// 金額フォーマット（例：1,234,567円）
export const formatAmount = (amount, options = {}) => {
  const {
    onNoData = DISPLAY.NO_DATA,
    onError = DISPLAY.ERROR,
    onInvalid = DISPLAY.INVALID,
  } = options;

  if (amount === null || amount === undefined) return onNoData;
  if (typeof amount !== "number") return onError;
  if (isNaN(amount) || !isFinite(amount)) return onError;
  if (amount < 0) return onInvalid;
  return amount.toLocaleString() + "円";
};

// 口数フォーマット（例：1,234,567口）
export const formatCount = (count, options = {}) => {
  const {
    onNoData = DISPLAY.NO_DATA,
    onError = DISPLAY.ERROR,
    onInvalid = DISPLAY.INVALID,
  } = options;

  if (count === null || count === undefined) return onNoData;
  if (typeof count !== "number") return onError;
  if (isNaN(count) || !isFinite(count)) return onError;
  if (count < 0) return onInvalid;
  return count.toLocaleString() + "口";
};

// 日付フォーマット（例：2026年05月01日（金））
const WEEKDAYS = ["日", "月", "火", "水", "木", "金", "土"];

export const formatDate = (dateStr) => {
  if (!dateStr) return "-";
  const date = new Date(dateStr);
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  const w = WEEKDAYS[date.getDay()];
  return `${y}年${m}月${d}日（${w}）`;
};

// 和暦フォーマット（例：令和8年05月01日）
export const formatWareki = (dateStr) => {
  if (!dateStr) return "-";
  const date = new Date(dateStr);
  return new Intl.DateTimeFormat("ja-JP-u-ca-japanese", {
    era: "long",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(date);
};

// 回数フォーマット（例：第123456回）
export const formatRound = (round, options = {}) => {
  const { onNoData = DISPLAY.NO_DATA, onError = DISPLAY.ERROR } = options;

  if (round === null || round === undefined) return onNoData;
  if (typeof round !== "number") return onError;
  if (isNaN(round) || round < 1) return onError;
  return `第${round}回`;
};

// 最新情報
export const isNew = (dateStr) => {
  if (!dateStr) return false;
  const diff = (new Date() - new Date(dateStr)) / (1000 * 60 * 60 * 24);
  return diff <= 7;
};
